import { useBackend } from "../../services";

export const useDeletePendingEmail = () => {
  const { deleteRequest } = useBackend();
  const deletePendingEmail = () => deleteRequest("user/email");
  return { deletePendingEmail };
};
